import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("number-input", () => {
    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-number-input max="100" min="20" step="5" value="50"/>`);
        const el = await page.find("ux-number-input");
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-number-input max="100" min="20" step="5" value="50"/>`);
    });
});

describe("disabledMinusButton", () => {
    it("should disable minus button if disableMinusButton flag is set and value is <= min", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-number-input min="0" max="20" value="0" disabled-minus-button></ux-number-input>`);
        const el = await page.find("ux-number-input");
        expect(el).toHaveClass("hydrated");
        expect(el).toMatchSnapshot();
        expect(el).not.toHaveClass("ux-number-input__btn--disabled");

        el.setProperty("value", 1);
        await page.waitForChanges();
        expect(el).not.toHaveClass("ux-number-input__btn--disabled");

        el.setProperty("value", 0);
        await page.waitForChanges();
        const btn = await page.find(".ux-number-input__btn");
        expect(btn).toHaveClass("ux-number-input__btn--disabled");
        expect(el).toMatchSnapshot();

        el.setProperty("value", 0);
        el.setProperty("disabledMinusButton", false);
        await page.waitForChanges();
        expect(btn).not.toHaveClass("ux-number-input__btn--disabled");
    });
});
